<div class="container-fluid service-change-wrapper">
  <div class="page-container">
    <div class="row justify-content-center">
      <div class="col-12">
        <form [formGroup]="serviceChangeForm" (ngSubmit)="onSubmit()">
          <div class="row mb-2">
            <div class="col-12">
              <label>Select Request Type</label>
              <mat-button-toggle-group
                class="cp"
                #requestTypeToggleBtn="matButtonToggleGroup"
                [formControl]="serviceChangeForm.controls.requestType"
                (change)="onRequestTypeChange($event.value)"
                [vertical]="vertical">
                <mat-button-toggle [value]="SERVICE_CHANGE_TYPES.RECURRING">
                  New Services
                </mat-button-toggle>
                <mat-button-toggle
                  [value]="SERVICE_CHANGE_TYPES.SCHEDULE_CHANGE">
                  Service Frequency Change
                </mat-button-toggle>
                <mat-button-toggle [value]="SERVICE_CHANGE_TYPES.CANCELLATION">
                  Cancellation
                </mat-button-toggle>
              </mat-button-toggle-group>
            </div>

            <ng-container
              *ngIf="isRecurringRequestType || isCancellationRequestType">
              <div class="col-12 mt-3">
                <label>Select Site Type</label>
                <mat-button-toggle-group
                  class="cp"
                  #siteTypeToggleBtn="matButtonToggleGroup"
                  [formControl]="serviceChangeForm.controls.siteType"
                  (change)="onSiteTypeChange($event.value)"
                  [vertical]="vertical">
                  <mat-button-toggle
                    [value]="RECURRING_SITE_TYPE.NEW_SITE"
                    *ngIf="isRecurringRequestType">
                    New Site
                  </mat-button-toggle>
                  <mat-button-toggle
                    [value]="RECURRING_SITE_TYPE.EXISTING_SITE"
                    *ngIf="isRecurringRequestType">
                    New Service
                  </mat-button-toggle>
                  <ng-container *appFeature="'CancelSite'">
                    <mat-button-toggle
                      [value]="SERVICE_CHANGE_TYPES.CANCEL_SITE"
                      *ngIf="isCancellationRequestType">
                      Cancel Site
                    </mat-button-toggle>
                  </ng-container>
                  <mat-button-toggle
                    [value]="SERVICE_CHANGE_TYPES.CANCEL_SERVICE"
                    *ngIf="isCancellationRequestType">
                    Cancel Service
                  </mat-button-toggle>
                </mat-button-toggle-group>
              </div>
            </ng-container>
          </div>
          <div id="required-fields">
            Fields marked with an * are required fields.
          </div>
          <div class="row mb-2">
            <app-dropdown-select
              class="col-12 col-lg-6"
              [parentForm]="serviceChangeForm"
              placeholderText="Select Billing Account"
              controlName="customerId"
              labelText="Billing Account"
              [options]="billingAccountDropdownOptions"
              *ngIf="isNewSiteType">
            </app-dropdown-select>

            <mat-form-field
              class="col-12 col-lg-6"
              appearance="outline"
              *ngIf="isExistingSiteType || isCancellationRequestType">
              <mat-label>Site Name:</mat-label>
              <input
                type="text"
                [placeholder]="
                  (isSitesLoading$ || isAllServiceSchedulesLoading$ | async)
                    ? 'Loading Sites...'
                    : 'Select Site Name'
                "
                aria-label="Site Name"
                matInput
                formControlName="siteId"
                [matAutocomplete]="auto"
                [readonly]="
                  isSitesLoading$ || isAllServiceSchedulesLoading$ | async
                "
                required />
              <button
                *ngIf="serviceChangeForm.get('siteId')?.value"
                mat-icon-button
                matSuffix
                aria-label="Clear"
                (click)="
                  serviceChangeForm.get('siteId').setValue('');
                  serviceChangeForm.get('siteId').updateValueAndValidity()
                ">
                <mat-icon>close</mat-icon>
              </button>
              <mat-autocomplete
                #auto="matAutocomplete"
                [displayWith]="displayFn"
                clea>
                <mat-option
                  *ngFor="let option of filteredOptions | async"
                  [value]="option">
                  {{ option.text }}
                </mat-option>
              </mat-autocomplete>
              <mat-hint
                *ngIf="
                  serviceChangeForm.controls.siteId?.value?.value &&
                  isScheduleChangeRequestType &&
                  serviceSchedules.length === 0
                "
                class="mat-error">
                No schedules available for the selected site.
              </mat-hint>
            </mat-form-field>

            <app-text-input
              class="col-12 col-lg-6"
              controlName="siteName"
              placeholder="Site Name"
              [parentForm]="serviceChangeForm"
              *ngIf="isNewSiteType">
            </app-text-input>

            <app-text-input
              class="col-12 col-lg-6"
              controlName="address"
              placeholder="Address"
              [parentForm]="serviceChangeForm">
            </app-text-input>

            <app-text-input
              class="col-12 col-lg-3"
              [parentForm]="serviceChangeForm"
              controlName="city"
              label="City"
              placeholder="City"
              *ngIf="isNewSiteType">
            </app-text-input>

            <app-dropdown-select
              class="col-12 col-lg-3"
              [parentForm]="serviceChangeForm"
              controlName="state"
              labelText="State"
              [options]="statesDropdownOptions"
              *ngIf="isNewSiteType">
            </app-dropdown-select>

            <app-text-input
              class="col-12 col-lg-6"
              [parentForm]="serviceChangeForm"
              controlName="zipcode"
              label="Zip Code"
              placeholder="Zip Code"
              *ngIf="isNewSiteType">
            </app-text-input>

            <app-text-input
              class="col-12 col-lg-6"
              [parentForm]="serviceChangeForm"
              hidden
              controlName="name"
              placeholder="Contact Name">
            </app-text-input>

            <app-text-input
              class="col-12 col-lg-6"
              [parentForm]="serviceChangeForm"
              hidden
              controlName="email"
              placeholder="Email Address">
            </app-text-input>

            <app-text-input
              class="col-12 col-lg-6"
              [parentForm]="serviceChangeForm"
              controlName="phone"
              type="tel"
              placeholder="Enter Phone Number"
              [readonly]="user.isPhoneValidated">
            </app-text-input>

            <app-multiple-email-input
              *ngIf="isEmailNotificationEnabled"
              class="col-12 col-lg-6"
              [parentForm]="serviceChangeForm"
              controlName="additionalEmailAddress"
              label="Additional Emails"
              placeholder="Additional Emails"
              maxLength="255">
            </app-multiple-email-input>

            <app-dropdown-select
              class="col-12 col-lg-6"
              [parentForm]="serviceChangeForm"
              placeholderText="Select Waste Stream"
              controlName="wasteStream"
              labelText="Waste Stream"
              [options]="wasteStreamDropdownOptions"
              *ngIf="!isCancelSiteType">
            </app-dropdown-select>

            <app-dropdown-select
              class="col-12 col-lg-3"
              [parentForm]="serviceChangeForm"
              placeholderText="Select Equipment Type"
              controlName="equipmentType"
              [labelText]="addNewToLabel + 'Equipment Type'"
              [options]="equipmentTypeDropdownOptions"
              *ngIf="!isCancelSiteType && !isScheduleChangeRequestType">
            </app-dropdown-select>

            <app-dropdown-select
              class="col-12 col-lg-3"
              [parentForm]="serviceChangeForm"
              placeholderText="Select Equipment Size"
              controlName="equipmentSize"
              [labelText]="addNewToLabel + 'Equipment Size'"
              [options]="equipmentSizeDropdownOptions"
              *ngIf="!isCancelSiteType && !isScheduleChangeRequestType">
            </app-dropdown-select>

            <mat-form-field
              appearance="outline"
              class="col-12 col-lg-6"
              *ngIf="!isCancellationRequestType">
              <mat-label>{{ addNewToLabel }}Pick Up Frequency</mat-label>
              <mat-select
                [formControl]="serviceChangeForm.controls.pickupFrequency"
                placeholder="Select Pick Up Frequency">
                <mat-option value="Weekly">Weekly</mat-option>
                <mat-option value="BI-Weekly">BI-Weekly</mat-option>
                <mat-option value="Monthly">Monthly</mat-option>
                <mat-option value="Other">Other</mat-option>
              </mat-select>
            </mat-form-field>

            <div
              *ngIf="
                serviceChangeForm.controls.pickupFrequency.value === 'Weekly' ||
                serviceChangeForm.controls.pickupFrequency.value === 'BI-Weekly'
              "
              class="col-12 col-lg-6">
              <label>Pick Up Dates</label>
              <mat-button-toggle-group
                name="ingredients"
                aria-label="Ingredients"
                class="cp"
                multiple
                [formControl]="serviceChangeForm.controls.pickupWeekDays"
                [vertical]="vertical">
                <mat-button-toggle value="Sun">Sun</mat-button-toggle>
                <mat-button-toggle value="Mon">Mon</mat-button-toggle>
                <mat-button-toggle value="Tue">Tue</mat-button-toggle>
                <mat-button-toggle value="Wed">Wed</mat-button-toggle>
                <mat-button-toggle value="Thu">Thu</mat-button-toggle>
                <mat-button-toggle value="Fri">Fri</mat-button-toggle>
                <mat-button-toggle value="Sat">Sat</mat-button-toggle>
              </mat-button-toggle-group>
            </div>

            <mat-form-field
              appearance="outline"
              *ngIf="
                serviceChangeForm.controls.pickupFrequency.value === 'Monthly'
              "
              class="col-12 col-lg-6 multiple-date-picker">
              <mat-label>Pick Up Dates</mat-label>
              <mat-hint>Select up to 4 days</mat-hint>
              <mat-chip-list
                #chipList
                aria-label="Choose a date"
                (click)="picker.open()">
                <mat-chip
                  *ngFor="
                    let value of serviceChangeForm.controls.pickupDates.value
                  "
                  [selectable]="false"
                  [removable]="true"
                  (removed)="remove(value)"
                  color="accent"
                  selected>
                  {{ getDay(value) }}
                  <mat-icon matChipRemove *ngIf="true">cancel</mat-icon>
                </mat-chip>
                <input
                  [value]="resetModel"
                  matInput
                  [matDatepicker]="picker"
                  placeholder="Pick Up Dates"
                  (dateChange)="dateChanged($event)"
                  [matChipInputFor]="chipList"
                  hidden
                  [min]="minDate"
                  [max]="maxDate" />
              </mat-chip-list>
              <mat-datepicker-toggle
                matSuffix
                [for]="picker"></mat-datepicker-toggle>
              <mat-datepicker
                #picker
                [startAt]="init"
                [dateClass]="dateClass"
                panelClass="multiDatePicker"></mat-datepicker>
            </mat-form-field>

            <mat-form-field class="col-12 col-lg-6" appearance="outline">
              <mat-label>Message</mat-label>
              <textarea
                matInput
                #message
                [maxlength]="MESSAGE_MAX_LENGTH"
                placeholder="Message"
                [formControl]="serviceChangeForm.controls.message"></textarea>
              <mat-hint align="start"></mat-hint>
              <mat-hint align="end">
                {{ message.value.length }} / {{ MESSAGE_MAX_LENGTH }}
              </mat-hint>
            </mat-form-field>

            <app-file-upload
              *ngIf="isCancellationRequestType && isCancelSiteType"
              class="col-12 col-lg-6"
              [showValidationError]="
                serviceChangeForm?.controls.fileUpload.touched &&
                serviceChangeForm?.controls.fileUpload.invalid
              "
              [label]="'Upload Image'"
              [isRequired]="
                serviceChangeForm.controls.fileUpload.errors?.required
              "
              [maxFiles]="5"
              (onFileChange)="setFiles($event)"
              [placeholder]="'Drag and drop an image file here or click'">
            </app-file-upload>
          </div>

          <div class="row submit-container pt-4">
            <div class="col-12 col-lg-auto">
              <app-submit-input
                [disabled]="!serviceChangeForm.valid"
                [parentForm]="serviceChangeForm"
                controlName="submit"
                value="Submit">
              </app-submit-input>
              <button
                color="primary"
                [disabled]="
                  !serviceChangeForm.dirty || !serviceChangeForm.touched
                "
                [ngClass]="
                  !serviceChangeForm.dirty || !serviceChangeForm.touched
                    ? 'disabled'
                    : null
                "
                class="cancel-button mt-3 mt-sm-0"
                type="button"
                (click)="onServiceChangeFormCancel()">
                Cancel
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
